export function tabs() {
    $('.tabs-holder .tabs-nav').on('click', 'a', function (e) {
        e.preventDefault();

        let tab = $(this).parent();
        let tabIndex = tab.index();
        let tabPanel = tab.closest('.tabs-holder');
        let tabPane = tabPanel.find('.tab').eq(tabIndex);

        tabPanel.find('.tabs-nav').each(function () {
            let $this = $(this);
            $this.find("li").removeClass('active');
            $this.find("li").eq(tabIndex).addClass('active');
        })
        tabPanel.find('.tab.active').removeClass('active');
        tabPane.addClass('active');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js